/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsHeaderStats
 */
export interface AllShipmentsHeaderStats {
  /**
   *
   * @type {number}
   * @memberof AllShipmentsHeaderStats
   */
  uniqueShipments: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsHeaderStats
   */
  totalQuotes: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsHeaderStats
   */
  numberBooked: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsHeaderStats
   */
  winRatePercent: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsHeaderStats
   */
  companiesBooked: number;
}

/**
 * Check if a given object implements the AllShipmentsHeaderStats interface.
 */
export function instanceOfAllShipmentsHeaderStats(
  value: object,
): value is AllShipmentsHeaderStats {
  if (!("uniqueShipments" in value) || value["uniqueShipments"] === undefined)
    return false;
  if (!("totalQuotes" in value) || value["totalQuotes"] === undefined)
    return false;
  if (!("numberBooked" in value) || value["numberBooked"] === undefined)
    return false;
  if (!("winRatePercent" in value) || value["winRatePercent"] === undefined)
    return false;
  if (!("companiesBooked" in value) || value["companiesBooked"] === undefined)
    return false;
  return true;
}

export function AllShipmentsHeaderStatsFromJSON(
  json: any,
): AllShipmentsHeaderStats {
  return AllShipmentsHeaderStatsFromJSONTyped(json, false);
}

export function AllShipmentsHeaderStatsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsHeaderStats {
  if (json == null) {
    return json;
  }
  return {
    uniqueShipments: json["uniqueShipments"],
    totalQuotes: json["totalQuotes"],
    numberBooked: json["numberBooked"],
    winRatePercent: json["winRatePercent"],
    companiesBooked: json["companiesBooked"],
  };
}

export function AllShipmentsHeaderStatsToJSON(
  json: any,
): AllShipmentsHeaderStats {
  return AllShipmentsHeaderStatsToJSONTyped(json, false);
}

export function AllShipmentsHeaderStatsToJSONTyped(
  value?: AllShipmentsHeaderStats | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    uniqueShipments: value["uniqueShipments"],
    totalQuotes: value["totalQuotes"],
    numberBooked: value["numberBooked"],
    winRatePercent: value["winRatePercent"],
    companiesBooked: value["companiesBooked"],
  };
}
